export const tickets = {
  refresh: 'tickets-refreshed',
  categories: 'categories-received',
  list: 'tickets-list-received',
  archived: 'archived-tickets-received',
  details: 'ticket-data-received',
  rsp: 'rsp-tickets-list-received',
  get: 'ticket-data-received',
  post: 'ticket-created',
  put: 'ticket-updated'
}
